import React from "react";
import t from '../../../helpers/t';
import Biscuit from '../../../../utils/Biscuit';
const NewPricetariffButton = (props) => {

  const onButtonClicked = (e) => {
            props.onClicked(e);
        };

  return (
    <>
      <a
          href={"/pricetariffs/add"}
          id="inb-c-left-bar-add-resource"
          className={"button beautify beautify-" + Biscuit.get('user.client_id')}
      >
          <i className="fi fi-page-add"></i>
          <span>
              {t('add_${a}',{a:t('pricetariff',null, 'capital')})}
          </span>
      </a>
    </>
  );
};
export default NewPricetariffButton;